import React from 'react';
import { ZapIcon, BadgeDollarSignIcon, UsersIcon, PackageCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [ZapIcon, BadgeDollarSignIcon, UsersIcon, PackageCheckIcon];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section id="why-us" className="w-full bg-forest py-20 lg:py-28" data-id="element-239" data-mp="u6m5grepnbiu">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16 lg:px-8" data-id="element-240" data-mp="g7mkpuubjgry">
        <div data-id="element-241" data-mp="l6zdew7vfi2g">
          <h2 className="font-display text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-242" data-mp="l7in5pndb05e">
            {t.why.title}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/75" data-id="element-243" data-mp="b89z1df6ofqy">
            {t.why.intro}
          </p>
          <dl className="mt-8 flex gap-10 border-t border-white/15 pt-8" data-id="element-244" data-mp="21kfqqd64fv5c">
            <div data-id="element-245" data-mp="25mkjl9oqwnqx">
              <dt className="text-sm font-semibold text-white/60" data-id="element-246" data-mp="25n2osvtdycaz">
                {t.why.basedInLabel}
              </dt>
              <dd className="font-display text-lg font-bold text-white" data-id="element-247" data-mp="1ndlpobb0oet7">
                {t.why.basedInValue}
              </dd>
            </div>
            <div data-id="element-248" data-mp="1idpsauwtrlmm">
              <dt className="text-sm font-semibold text-white/60" data-id="element-249" data-mp="1x46tcd5js9iz">
                {t.why.servingLabel}
              </dt>
              <dd className="font-display text-lg font-bold text-white" data-id="element-250" data-mp="1s53qmzd1ife6">
                {t.why.servingValue}
              </dd>
            </div>
          </dl>
        </div>

        <ul className="grid gap-px overflow-hidden rounded-lg bg-white/15 sm:grid-cols-2" data-id="element-251" data-mp="zgy3y72fegbp">
          {t.why.items.map((benefit, index) => {
          const Icon = icons[index];
          return <li key={benefit.title} className="bg-forest p-7" data-id="element-252" data-mp="19f5jqmkzasc4" data-mpi={index}>
                <Icon className="h-7 w-7 text-rust-light" aria-hidden="true" data-id="element-253" data-mp="19gyqe1vldck4" />
                <h3 className="mt-5 font-display text-lg font-bold text-white" data-id="element-254" data-mp="2prkk1tink8un">
                  {benefit.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/70" data-id="element-255" data-mp="2rx93nkpidq8q">
                  {benefit.description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}